import React from 'react'
import { useNavigate } from 'react-router-dom'

import styles from './DemoModeInfo.module.scss'

import { Gamepad as DemoIcon } from '../../../icons'
import CustomButton from 'components/elements/buttons/CustomButton'

interface IDemoModeInfoProps {
  className?: string
}

const DemoModeInfo: React.FC<IDemoModeInfoProps> = (props) => {
  const { className } = props

  const navigate = useNavigate()

  const handleBtnClick = () => {
    navigate('/pricing')
  }

  return (
    <div
      className={`
        ${styles.container}
        ${className || ''}
      `}
    >
      <div className={styles.iconWrapper}>
        <DemoIcon />
      </div>

      <div className={styles.content}>
        <div className={styles.title}>Demo mode</div>

        <p className={styles.description}>
          This is a preview of the product functionality. Valid connection data
          will be available with a{' '}
          <CustomButton color={'ghostAlt'} onClick={handleBtnClick}>
            purchased subscription.
          </CustomButton>
        </p>
      </div>
    </div>
  )
}

export default DemoModeInfo
